import { UnifiedPersonFilterKeyString } from 'CitizenProfile/types'
import { CITIZEN_INITIAL_FILTER } from '../citizens'

export const UNIFIED_PERSON_INITIAL_FILTER: UnifiedPersonFilterKeyString = CITIZEN_INITIAL_FILTER
